import { data } from '../../svg/ActionKey/data';
import { makeIcon } from '../makeIcon';

export const ActionKey = makeIcon(data, 'action_key', 'ActionKey');

export default ActionKey;
